const KEY = "@Messages/";
export const LOAD_MESSAGES_SUCCESS = `${KEY}LOAD_MESSAGES_SUCCESS`;
export const LOAD_MESSAGE_TEMPLATE_SUCCESS = `${KEY}LOAD_MESSAGE_TEMPLATE_SUCCESS`;
export const LOAD_MESSAGE_TEMPLATE_ERROR = `${KEY}LOAD_MESSAGE_TEMPLATE_ERROR`;
export const LOAD_MESSAGE_UNREAD_COUNT_SUCCESS = `${KEY}LOAD_MESSAGE_UNREAD_COUNT_SUCCESS`;
export const PENDING_SEND_MESSAGE_SUCCESS = `${KEY}PENDING_SEND_MESSAGE_SUCCESS`;
export const PENDING_MESSAGE_DELETED_SUCCESS = `${KEY}PENDING_MESSAGE_DELETED_SUCCESS`;
export const NEW_MESSAGE_RECEIVED = `${KEY}NEW_MESSAGE_RECEIVED`;
export const MESSAGE_READ_SUCCESS = `${KEY}MESSAGE_READ_SUCCESS`;
export const MESSAGE_UNREAD_SUCCESS = `${KEY}MESSAGE_UNREAD_SUCCESS`;
export const CURRENT_MESSAGE_DOCUMENT_IDS_UPDATED = `${KEY}CURRENT_MESSAGE_DOCUMENT_IDS_UPDATED`;
